// Calcul d'aperçu d'un devis (le serveur refait le calcul officiel).
// Montants en cents entiers pour éviter les erreurs d'arrondi.

export const TPS_RATE_LABEL = '5 %';
export const TVQ_RATE_LABEL = '9,975 %';

const normalize = (value) => String(value ?? '').trim().replace(/\s/g, '').replace(',', '.');

export const parseNumber = (value) => {
  const text = normalize(value);
  if (!/^-?\d+(\.\d+)?$/.test(text)) return null;
  return Number(text);
};

export const toCents = (value) => {
  const number = parseNumber(value);
  return number === null ? null : Math.round(number * 100);
};

export const lineCents = (line) => {
  const quantity = parseNumber(line.quantity);
  const unit = toCents(line.unit_price);
  if (quantity === null || unit === null) return 0;
  return Math.round(quantity * unit);
};

export const estimateTotals = (lines, taxable = true) => {
  const subtotal = lines.reduce((sum, line) => sum + lineCents(line), 0);
  const tps = taxable ? Math.round((subtotal * 5) / 100) : 0;
  const tvq = taxable ? Math.round((subtotal * 9975) / 100000) : 0;
  return { subtotal, tps, tvq, total: subtotal + tps + tvq };
};

export const formatCents = (cents) => {
  const sign = cents < 0 ? '-' : '';
  const absolute = Math.abs(cents);
  const whole = Math.floor(absolute / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${sign}${whole},${String(absolute % 100).padStart(2, '0')} $`;
};

export const formatAmount = (value) => {
  const cents = toCents(value);
  return cents === null ? '' : formatCents(cents);
};

// Lignes prêtes pour l'API : nombres au format « 12.50 ».
export const lineErrors = (line) => {
  const errors = [];
  if (!String(line.description || '').trim()) errors.push('description');
  const quantity = parseNumber(line.quantity);
  if (quantity === null || quantity <= 0) errors.push('quantité');
  const price = normalize(line.unit_price);
  if (!/^-?\d+(\.\d{1,2})?$/.test(price)) errors.push('prix');
  return errors;
};

export const toPayloadLines = (lines) =>
  lines.map((line) => ({
    description: String(line.description).trim(),
    quantity: normalize(line.quantity),
    unit_price: normalize(line.unit_price),
  }));

export const emptyLine = () => ({ description: '', quantity: '1', unit_price: '' });
